import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/total-return-calculator',
  component: () => import('../../routes/TotalReturnCalculator.svelte'),
  card: {
    id: 'total-return',
    title: 'Total Return',
    description: 'Calculate total return, annualized return (CAGR), capital gains, and income from your investments including stocks, bonds, and funds.',
    icon: 'insights',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/total-return-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Total Return Calculator – Capital Gains + Income Return',
    description: 'Free total return calculator to measure your complete investment performance. Enter initial investment, final value, and distributions to calculate total return, annualized return (CAGR), and income vs capital gain breakdown.',
  },
};

export default meta;